import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { Company } from 'utils/types';
import { Meta } from '@storybook/react';

import { companiesTransformer } from '../transformers';
import c from '../utils/constants';

interface Result {
  data: Company;
  meta: Meta;
}

export default function useGetCompany(id: string, params = {}, enabled = true) {
  const { state } = useProvider();
  const args = state;
  const { accountId, accountUserId } = useAdminParams();
  return useQuery<Company, Error>({
    queryKey: [c.COMPANIES, id],
    queryFn: async () => {
      const api = new Api(args);

      const data: Result = await api.get(
        await withAcl({
          account: {
            url: `api/v1/contacts/companies/${id}`,
            params,
            transformer: companiesTransformer.company,
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/contacts/companies/${id}`,
            params,
            transformer: companiesTransformer.company,
          },
        }),
      );

      return data?.data;
    },
    enabled: !!id && enabled,
  });
}
